import '@babel/polyfill';
import Vue from 'vue';
import './plugins/VuetifyPlugin';
import App from './App.vue';
import BootstrapVue from 'bootstrap-vue';
import VueRouter from 'vue-router';
import axios from 'axios';
import VueAxios from 'vue-axios';
import moment from 'moment';
import underscore from 'vue-underscore';
import DraggableTreeView from "sl-vue-tree";
import 'url-search-params-polyfill';
import TheStore from './store/TheStore';
import UUID from 'vue-uuid';

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import htmlToPdfmake  from "html-to-pdfmake";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

import UErrorHandling from "@/components/common/UErrorHandling.vue";
import UHelpText from "@/components/common/UHelpText.vue";
import ULoader from "@/components/common/ULoader.vue";
import UMultilineMultilanguageTextInput from "@/components/common/UMultilineMultilanguageTextInput.vue";
import UValidationChecker from "@/components/common/UValidationChecker.vue";
import numeral from 'numeral';
import numFormat from 'vue-filter-number-format';

import {
    GetCurrentUserName,
    IsUserInRole
} from "@/services/user.service.js";

import {
    UniaGAVConstants
} from "@/assets/configuration/constants.js";

import {
    Routes
} from '@/routes/Routes.js';

import {
    RefreshToken
} from "@/services/user.service.js";

import {
    GetAllValidationRules
} from "@/services/validation.rules.service.js";

import 'url-search-params-polyfill';

Vue.config.productionTip = false

// This will be used a lot, so we use it globally
Vue.component("UErrorHandling", UErrorHandling);
Vue.component("UHelpText", UHelpText);
Vue.component("ULoader", ULoader);
Vue.component("UMultilineMultilanguageTextInput", UMultilineMultilanguageTextInput);
Vue.component("UValidationChecker", UValidationChecker);

// Filters
Vue.filter('numFormat', numFormat(numeral));
Vue.filter('ruleValueDisplay', function(value) {
    if (value === 'Y') {
        return 'Ja';
    } else if (value === 'N') {
        return 'Nein';
    } else {
        return value;
    }
})

// Components
Vue.use(BootstrapVue);
Vue.use(UUID);
Vue.use(VueRouter);
Vue.use(moment);
Vue.use(pdfMake);
Vue.use(htmlToPdfmake);
Vue.use(underscore);
Vue.use(DraggableTreeView);
Vue.use(VueAxios, axios);
Vue.use(require('vue-moment'));
window.jsonFormData = require('json-form-data');

// these will be used often, so they are declared globally. 
// To use in Template, use $GetCurrentUserName()
// To use in vue Script, use this.$GetCurrentUserName()
Vue.prototype.$GetCurrentUserName = GetCurrentUserName;
Vue.prototype.$IsUserInRole = IsUserInRole;
Vue.prototype.$UniaGAVConstants = UniaGAVConstants;

GetAllValidationRules(
    rules => {
        Vue.prototype.$validationRules = rules;
    },
    error => {
        console.log("Could not load validation rules.");
        console.log(error);
    }
);


const router = new VueRouter({
    routes: Routes,
    mode: 'history'
});



Vue.prototype.$eventBus = new Vue();


new Vue({
    el: '#app',
    router,
    store: TheStore,
    App,
    
    created() {

        // whenever the app is loaded, refresh the user token
        RefreshToken();

        
    },
    render: h => h(App)
})